import { render } from "./tab-result-subject.vue?vue&type=template&id=184d86a6&scoped=true"
import script from "./tab-result-subject.vue?vue&type=script&lang=js"
export * from "./tab-result-subject.vue?vue&type=script&lang=js"

import "./tab-result-subject.vue?vue&type=style&index=0&id=184d86a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184d86a6"]])

export default __exports__